<template>
    <div class="bg">
        <div>
            日期：点击切换日期<br>
            <span v-for="(item, index) in dayData" @click="chooseThis(item,index)">{{item.day}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br></span>

            <br>
            <span @click="chooseTime(item,index);" v-for="(item, index) in timeData" :class="[item.type==1?'':(item.type==2?'red':'blue' ), 'normal']">
                {{ item.title }}
            </span>
            <br>
            <span @click="resetselectedArr">清空已选</span>
            <br>
            <span @click="getselectedArr">取出已选</span>
            <br>
            <span v-html="text"></span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                // 当前日期
                nowDay:null,
                // day:日期     daySelect:当前日期不可选择时间段      selected:用户选择的时间
                dayData:[
                    {
                        id:1,
                        day:'今天 19',
                        daySelect:[1,2,3],
                        selected:[]
                    },
                    {
                        id:2,
                        day:'明天 20',
                        daySelect:[2,3,4,5],
                        selected:[]
                    },
                    {
                        id:3,
                        day:'明天 21',
                        daySelect:[8,9,10,11],
                        selected:[]
                    },
                ],
                // type: 1:默认可选   2:已选    3:不可选
                timeData:[
                    {
                        title:'0:00',
                        id: 1,
                        type:'1'
                    },
                    {
                        title:'0:30',
                        id: 2,
                        type:'1'
                    },
                    {
                        title:'1:00',
                        id: 3,
                        type:'1'
                    },
                    {
                        title:'1:30',
                        id: 4,
                        type:'1'
                    },
                    {
                        title:'2:00',
                        id: 5,
                        type:'1'
                    },
                    {
                        title:'2:30',
                        id: 6,
                        type:'1'
                    },
                    {
                        title:'3:00',
                        id: 7,
                        type:'1'
                    },
                    {
                        title:'3:30',
                        id: 8,
                        type:'1'
                    },
                    {
                        title:'4:00',
                        id: 9,
                        type:'1'
                    },
                    {
                        title:'4:30',
                        id: 10,
                        type:'1'
                    },
                    {
                        title:'5:00',
                        id: 11,
                        type:'1'
                    },
                    {
                        title:'5:30',
                        id: 12,
                        type:'1'
                    },
                    {
                        title:'6:00',
                        id: 13,
                        type:'1'
                    },
                    {
                        title:'6:30',
                        id: 14,
                        type:'1'
                    },
                ],
                // 用户选择时间
                selectedArr:[],
                text:'',
            }
        },
        mounted(){
            this.chooseThis(this.dayData[0],0);
        },
        methods: {
            getselectedArr(){
                let text = '';
                console.log(this.dayData);
                for(let i in this.dayData){
                    let thisText = this.dayData[i].day + '已选时间: ';
                    this.dayData[i].selected.sort();
                    for(let p in this.dayData[i].selected){
                        thisText = thisText + this.timeData[this.dayData[i].selected[p]].title + '&nbsp;&nbsp;,&nbsp;&nbsp;';
                    }
                    thisText = thisText + '<br>';
                    text = text + thisText;
                }
                this.text = text;
            },
            chooseTime(tiemData,index){
                console.log(tiemData);
                if(tiemData.type == 1){
                    // 时间可选
                    this.selectedArr.push(index);
                    this.dayData[this.nowDay].selected.push(index);
                    this.setDataStyle();
                }else{
                    // 时间不可选
                }
            },
            chooseThis(dayData, index){
                this.resetTimeData();
                this.nowDay = index;
                this.setDataStyle();
            },
            resetTimeData(){
                for(let i in this.timeData){
                    this.timeData[i].type = 1;
                }
                this.text = '';
            },
            resetselectedArr(){
                this.selectedArr = [];
                for(let i in this.dayData){
                    this.dayData[i].selected = [];
                }
                this.setDataStyle();
            },
            setDataStyle(){
                this.resetTimeData();
                for(let i in this.dayData[this.nowDay].daySelect){
                    this.timeData[this.dayData[this.nowDay].daySelect[i]].type = 3;
                }
                for(let p in this.dayData[this.nowDay].selected){
                    this.timeData[this.dayData[this.nowDay].selected[p]].type = 2;
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .normal{
        display: inline-block;
        background-color: #ccc;
        width: 30px;
        height: 30px;
        margin: 10px;
    }
    .red{
        background-color: #fdb7b7;
    }
    .blue{
        background-color: #8694fb;
    }
</style>
